/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const mediaScanStatusSchema = z.enum(['queued', 'scanning', 'clean', 'infected', 'error', 'skipped'])

export type MediaScanStatusSchema = z.infer<typeof mediaScanStatusSchema>
